/* opus-buy.js: the theme's add-to-cart glue. Owner: theme lead (J/THEME-PLAN.md, "Prices and add to cart").
 * Source: site-2026-09-21/tools/theme/opus-buy.js; copied into the theme by tools/theme-emit.mjs.
 *
 * Every add button B builds carries data-add ("broq", or "broq nmn spmd"), data-plan ("monthly" | "12" | "once")
 * and data-qty. On click this builds the cart lines from window.OpusCatalog (read from the store by Liquid) and
 * hands them to the cart drawer, window.OpusCart.add(items, {source}).
 * Round 3, CRO K5 (KB 10-platform/tracking-setup.md S04-0151 to S04-0156; cart-drawer.md 5.1 S03-N0071; sample
 * timeline-cart-drawer): a failed add never leaves the page. The drawer has already said why (its role=alert line),
 * so the cart the visitor had and the campaign that brought them stay as they were. Without the drawer the click
 * is not taken: the button's own href, Shopify's /cart/add link with return_to=/cart (theme-emit cartLinks: no
 * /cart/clear, no UTMs of ours), does the add, as it does with no script at all. */
(function () {
  'use strict';
  function catalog() { return (window.OpusCatalog && window.OpusCatalog.products) || {}; }

  /* 10AM A1 on PDPs (lead, 4 Oct 2026, about 5:30pm Pacific): a product page's button with all three ticked on a
     subscription carries data-all3="monthly" | "12" (buy.js); its box's data-all3 holds the store's ALL THREE
     variant and plan for each (theme-emit o_all3). One line, the /products stack box's own add: quantity 1 on Annual,
     the chosen count on Subscribe & Save. Anything missing and the three separate lines go in as before. */
  /* Mike, 4 Oct 2026, 7:27pm: there is no ALL THREE product; this one-line add is off and the three products go in */
  function all3For(el) {
    return null;
    var k = el.getAttribute('data-all3');
    if (k !== 'monthly' && k !== '12') return null;
    var box = el.closest && el.closest('[data-buy]');
    if (!box && el.id) box = document.getElementById(el.id.replace(/-go$/, ''));
    var A3 = null;
    try { A3 = JSON.parse((box && box.getAttribute('data-all3')) || 'null'); } catch (e) { A3 = null; }
    if (!A3 || !A3[k] || !A3[k].variant || !A3[k].plan) return null;
    var qty = k === '12' ? 1 : Math.max(1, Math.min(10, parseInt(el.getAttribute('data-qty'), 10) || 1));
    return [{ id: Number(A3[k].variant), quantity: qty, selling_plan: Number(A3[k].plan) }];
  }

  function itemsFor(el) {
    var a3 = all3For(el);
    if (a3) return a3;
    var keys = String(el.getAttribute('data-add') || '').split(/\s+/).filter(Boolean);
    var plan = el.getAttribute('data-plan') || 'monthly';
    var qty = Math.max(1, Math.min(10, parseInt(el.getAttribute('data-qty'), 10) || 1));
    var C = catalog(), items = [];
    for (var i = 0; i < keys.length; i++) {
      var P = C[keys[i]];
      if (!P) return null;
      /* a product on another plan than data-plan names it per product (the PDP's "Add X too" under the prepaid
         year puts the other product on Monthly: data-plan-<key>) */
      var pk = el.getAttribute('data-plan-' + keys[i]) || plan;
      if (pk === '12') {
        if (!P.prepaid || !P.prepaid.variantId) return null;
        var it = { id: Number(P.prepaid.variantId), quantity: qty };
        if (P.prepaid.planId) it.selling_plan = Number(P.prepaid.planId);
        items.push(it);
      } else if (pk === 'once') {
        items.push({ id: Number(P.variantId), quantity: qty });
      } else {
        if (!P.plans || !P.plans.monthly || !P.plans.monthly.id) return null;
        items.push({ id: Number(P.variantId), quantity: qty, selling_plan: Number(P.plans.monthly.id) });
      }
    }
    return items.length ? items : null;
  }

  /* the surface each add came from, for the line's hidden _src (cart builder's CA6): pdp (a product page's own
     button), pdp_both (the "Pairs with" box), products_stack (the /products stack box). A data-source on the
     button wins. */
  function sourceOf(el) {
    var s = el.getAttribute('data-source');
    if (s) return s;
    var id = el.id || '';
    if (id === 'buy-all-go') return 'products_stack';
    if (id === 'pairs-go') return 'pdp_both';
    if (id === 'buy-drawer-go') return 'pdp-sticky';
    if (id === 'buy-go' || id === 'buy-close-go') return 'pdp';
    var box = el.closest && el.closest('[data-buy]');
    return (box && box.id) || id || 'button';
  }
  /* Round 4, CRO K-5 (KB 10-platform/tracking-setup.md; pdp/cross-sell.md): on a product page's own button, its
     own product (data-add's first key, as buy.js writes it) keeps the button's source, pdp or pdp-sticky, and each
     ticked "Add X too" product is tagged pdp-too-<page product>, so an order says which page's card sold it. Read
     as an attach rate only, never a lift. */
  function perItem(el, items) {
    var id = el.id || '';
    if (el.getAttribute('data-source') || (id !== 'buy-go' && id !== 'buy-close-go' && id !== 'buy-drawer-go')) return items;
    var page = String(el.getAttribute('data-add') || '').split(/\s+/).filter(Boolean)[0] || '';
    for (var i = 1; i < items.length; i++) items[i].source = 'pdp-too-' + page;
    return items;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var el = e.target.closest && e.target.closest('[data-add]');
    if (!el) return;
    if (!window.OpusCart || typeof window.OpusCart.add !== 'function') return;   // no drawer: the href does it
    var items = itemsFor(el);
    if (!items) return;                       // let the href do it
    items = perItem(el, items);
    e.preventDefault();
    if (el.getAttribute('aria-busy') === 'true') return;
    el.setAttribute('aria-busy', 'true');
    var done = function () { el.removeAttribute('aria-busy'); };
    var p;
    try { p = window.OpusCart.add(items, { source: sourceOf(el) }); } catch (err) { p = Promise.reject(err); }
    Promise.resolve(p).then(done, function (err) {
      done();                                 // K5: stay here; the drawer shows the store could not be reached
      if (window.console) console.warn('opus-buy: add failed; the drawer says so, and the page stays', err);
    });
  }, false);

  /* The header count, until (or unless) the drawer script takes it over. */
  function paintCount() {
    if (window.OpusCart) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var n = c.item_count || 0;
      document.querySelectorAll('[data-cart-count]').forEach(function (x) { x.textContent = String(n); if (n > 0) x.removeAttribute('hidden'); else x.setAttribute('hidden', ''); });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintCount); else paintCount();
})();
